import AxessLogo from "../assets/InstallmentOptions/Axess.svg";
import BankkartLogo from "../assets/InstallmentOptions/Bankkart.svg";
import BonusLogo from "../assets/InstallmentOptions/Bonus.svg";
import MaximumLogo from "../assets/InstallmentOptions/Maximum.svg";
import ParafLogo from "../assets/InstallmentOptions/Paraf.svg";
import QNBLogo from "../assets/InstallmentOptions/QNB.svg";
import WorldLogo from "../assets/InstallmentOptions/World.svg";
const InstallmentData = {
  blogs: [
    {
      id: 1,
      title: "AxessLogo",
      alt: "AxessLogo",
      images: AxessLogo,
    },
    {
      id: 2,
      title: "BankkartLogo",
      alt: "BankkartLogo",
      images: BankkartLogo,
    },
    {
      id: 3,
      title: "BonusLogo",
      alt: "BonusLogo",
      images: BonusLogo,
    },
    {
      id: 4,
      title: "MaximumLogo",
      alt: "MaximumLogo",
      images: MaximumLogo,
    },
    {
      id: 5,
      title: "ParafLogo",
      alt: "ParafLogo",
      images: ParafLogo,
    },
    {
      id: 6,
      title: "QNBLogo",
      alt: "QNBLogo",
      images: QNBLogo,
    },
    {
      id: 7,
      title: "WorldLogo",
      alt: "WorldLogo",
      images: WorldLogo,
    },
  ],
};

export default InstallmentData;
